import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map, Observable, retry, throwError } from 'rxjs';
import { LoadingStatusService } from './services/loading-status.service';

export const httpRequestInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const lss = inject(LoadingStatusService);
  lss.setLoadingStatus(true);

  return next(request).pipe(
    retry(1),
    catchError((err: HttpErrorResponse) => {
      const message = err.error instanceof ErrorEvent ? `Error: ${err.error.message}` : `Error Status: ${err.status}\nMessage: ${err.message}`;
      console.error(message);
      lss.setLoadingError(message);
      lss.setLoadingStatus(false);
      return throwError(() => new Error(message));
    }),
    map((evt: HttpEvent<unknown>) => {
      if (evt instanceof HttpResponse) {
        lss.setLoadingStatus(false);
        lss.setLoadingError('');
      }
      return evt;
    }),
  );
};
